import { Text } from "$components";
import ReferenceLink from "./ReferenceLink";
import { useStyles } from "../styles/ProfileEDB.styles";
import { useProfileEDBContext } from "$containers/EDB/ProfileEDB/context/ProfileEDBContext";

export default function TitleHeader() {
  const classes = useStyles();
  const { idEdb, edb } = useProfileEDBContext();

  return (
    <div
      className={classes.titleCustom}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        flexWrap: "wrap",
      }}
    >
      <Text type="h2" style={{ margin: 0, paddingRight: 16 }}>
        {edb?.edbId || "Fiche EDB"}
      </Text>

      {edb?.project && (
        <>
          <ReferenceLink
            to={`/edbs/${idEdb}/projets/${edb.project._id}`}
            label={`Projet ${edb.project.name}`}
          />
          <span className={classes.headTextRefsSeparator}>{">"}</span>
        </>
      )}

      {edb?.dockyard && (
        <ReferenceLink
          to={`/edbs/${idEdb}/chantiers/${edb.dockyard._id}`}
          label={`Chantier ${edb.dockyard.name}`}
        />
      )}
    </div>
  );
}
